export default "__VITE_ASSET__Dl$O_DYC__"